import React, { Component } from 'react'
import util from '../util'
export default class Products extends Component {
  render() {
    const productItems = this.props.products.map( product => (
      <div key={product.id} className='col-md-3 my-2 mx-4 p-2 border border-primary border-2 rounded'>
        <div className='thumbnail text-center'>
          <a href={`#${product.id}`}>
            <img src={`/products/${product.sku}_2.jpg`} alt={product.title}/>
            <div>
              <p>{product.title}</p>
            </div>
          </a>
          <div>
            <strong>Price: {util.formatCurrency(product.price)}</strong><br/>
            <button 
              className='btn btn-primary'
              onClick={e => this.props.handleAddToCart(e,product)}
            >Add To Cart</button>
          </div>
        </div>
      </div>
    ))
    return (
      <div className='row'>
        {productItems}
      </div>
    )
  }
}
